module.exports = __webpack_public_path__ + "img/ppsittin.a9be8db3.jpg";